/* eslint-disable no-magic-numbers */

/** Digits only (DDD + number). */
export const sanitizePhone = (value: string): string =>
  value.replace(/\D/g, '').slice(0, 11);

export const formatPhoneMask = (digits: string): string => {
  const d = sanitizePhone(digits);
  if (d.length <= 2) {
    return d.length ? `(${d}` : '';
  }
  if (d.length <= 6) {
    return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  }
  if (d.length <= 10) {
    return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  }
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

/**
 * Valid Brazilian mobile/landline: 10 or 11 digits, DDD 11–99.
 */
export const validatePhone = (value: string): boolean => {
  const digits = sanitizePhone(value);
  if (digits.length !== 10 && digits.length !== 11) {
    return false;
  }
  const ddd = Number(digits.slice(0, 2));
  return ddd >= 11 && ddd <= 99;
};
